import DateRangePicker from './DateRangePickerWrapper';

export default DateRangePicker;
